import { DAYS } from './data';
export default function Days() {
  return (
    <div className="bg-[#F8E6DC] text-[#7A4A3F] min-h-screen">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-[3px] border-dashed border-[#B89C5C]"><p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#A8B89A] mb-3">— Page III / The four days · June 11 — 14, 2026</p><h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95] text-center">A four-day plan,<br />with a few breakfasts.</h1></section>
      <section className="max-w-[1100px] mx-auto px-8 lg:px-14 py-14 space-y-7">
        {DAYS.map((d, i) => (
          <article key={d.d} className="grid lg:grid-cols-[120px_140px_1fr] gap-6 items-start bg-[#FAF5EE] border border-[#B89C5C]/30 p-6 lg:p-8">
            <div><p className="font-serif italic text-5xl text-[#B89C5C]">{d.d}.</p><p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#A8B89A] mt-1">{d.date}</p></div>
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#7A4A3F]/55 lg:text-right">Day {String(i + 1).padStart(2, '0')}</div>
            <div>
              <h2 className="font-serif italic text-2xl lg:text-3xl">{d.t}</h2>
              <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-[#7A4A3F]/55 mt-1">{d.loc}</p>
              <p className="font-serif text-base text-[#7A4A3F]/75 mt-3 leading-[1.7]">{d.desc}</p>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
